export enum ProductTypeEnum
{
    Standard = 'Standard',
    Pack = 'Pack',
}

export const ProductTypeOptions = () => ([
    { value: ProductTypeEnum.Standard, text: $t('[[[Standardowy]]]') },
    { value: ProductTypeEnum.Pack, text: $t('[[[Zestaw]]]') }
]);

export const ProductTypeName = (value: ProductTypeEnum) => ProductTypeOptions().find(p => p.value === value)?.text || ProductTypeEnum[value];

// ----------------------------------------------------------------------------------------------------

export enum ProductStatusEnum
{
    Draft = 'Draft',
    WaitingForPublication = 'WaitingForPublication',
    Published = 'Published',
}

export const ProductStatusOptions = () => ([
    { value: ProductStatusEnum.Draft, text: $t('[[[Szkic]]]') },
    { value: ProductStatusEnum.WaitingForPublication, text: $t('[[[Oczekujący na publikację]]]') },
    { value: ProductStatusEnum.Published, text: $t('[[[Opublikowany]]]') }
]);

export const ProductStatusName = (value: ProductStatusEnum) => ProductStatusOptions().find(p => p.value === value)?.text || ProductStatusEnum[value];
